import * as ko from "knockout";
import {autobind} from "knockout-decorators";
import {myTripPicturesApi} from "../../../api/api-wrapper";
import {postbox} from "../../util/postbox";
import {TripPictureDto} from "../../../api/generated";
import globalState from "../../../global-state";
import i18nextko from "../../util/i18nko";

import 'knockout-file-bindings';
import 'knockout-file-bindings/knockout-file-bindings.css';
import {config} from "../../../globals";
import IConfig = config.IConfig;

export interface FileData {
    file: KnockoutObservable<File>;
    dataURL?: KnockoutObservable<string>;
    base64String?: KnockoutObservable<string>;
}

class ViewModelParams {
    public tripPicturePath: KnockoutObservable<string>;
    public tripPicturesVisible: KnockoutObservable<boolean>;
}

class ViewModel {

    public tripPicturePath: KnockoutObservable<string>;
    public tripPicturesVisible: KnockoutObservable<boolean>;

    public tripPictures: KnockoutObservable<TripPictureDto[]>;
    public tripPictureData: KnockoutObservable<FileData>;
    public tripPicturesGalleryVisible: KnockoutComputed<boolean>;
    public tripPictureUploadSubscription: KnockoutSubscription;

    public config: IConfig = config;

    constructor(params: ViewModelParams) {
        this.tripPictures = ko.observableArray([]);
        this.tripPicturePath = params.tripPicturePath;
        this.tripPicturesVisible = params.tripPicturesVisible;

        (<any>ko).fileBindings.defaultOptions.fileName = false;
        (<any>ko).fileBindings.defaultOptions.clearButton = false;

        this.tripPictureData = ko.observable({
            dataURL: ko.observable(),
            base64String: ko.observable(),
            file: ko.observable()
        });

        this.tripPictureUploadSubscription = this.tripPictureData().base64String
            .subscribe(() => this.uploadTripPicture());

        myTripPicturesApi.getTripPictures().then(result => this.tripPictures(result.data));
        this.tripPicturesGalleryVisible = ko.computed(() => {
            return this.tripPictures().length > 0;
        });
    }

    @autobind
    public selectTripPicture(tripPictureDto: TripPictureDto) {
        window.scrollTo({top: 0, left: 0, behavior: 'auto'});

        this.tripPicturePath(tripPictureDto.imageUrl);
        this.tripPicturesVisible(false);
    };

    public tripPictureUrl(tripPictureDto: TripPictureDto): string {
        return `${config.imagePath}/${tripPictureDto.imageUrl}`;
    }

    @autobind
    public uploadTripPicture() {
        if (this.tripPictureData() && this.tripPictureData().base64String()) {
            if (this.tripPictureData().file().type.search(/^image\/.*$/) == -1) {
                postbox.addError('tripPictures.errors.invalidImage');
                return Promise.reject();
            }

            globalState.loading(true);
            myTripPicturesApi
                .uploadPicture({
                    filename: this.tripPictureData().file().name,
                    mimeType: this.tripPictureData().file().type,
                    data: this.tripPictureData().base64String()
                })
                .then(response => {
                    this.tripPicturePath(response);
                    this.tripPicturesVisible(false);
                    globalState.loading(false)
                })
                .catch(err => {
                    console.error('failed to upload trip picture', err);
                    this.tripPicturesVisible(false);
                    globalState.loading(false)
                });
        }
    }

    @autobind
    public dispose() {
        this.tripPictureUploadSubscription.dispose();
    }

    public imageFileOptions() {
        return {
            noFileText: i18nextko.t("global.fileUpload.noFileText"),
            buttonText: i18nextko.t("global.fileUpload.button.choose"),
            changeButtonText: i18nextko.t("global.fileUpload.button.change"),
            clearButtonText: i18nextko.t("global.fileUpload.button.clear"),
            fileName: false
        };
    }
}

const componentName = 'tripPictures';
if (!ko.components.isRegistered(componentName)) {
    ko.components.register(componentName, {
        viewModel: (params: ViewModelParams) => {
            return new ViewModel(params)
        },
        template: <string>require('./tripPictures.html')
    })
}
